import { render } from "./BaseButtonGroup.vue?vue&type=template&id=71c4e94e"
import script from "./BaseButtonGroup.vue?vue&type=script&lang=js"
export * from "./BaseButtonGroup.vue?vue&type=script&lang=js"

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__